import React from "react";
import "../Assets/css/privacy-policy.css";
import vtLogo from "../Assets/Images/vt-purple-logo.png";
const PrivacyPolicy = () => {
  return (
    <>
      {" "}
      <div className="container privacy-policy">
        <img
          className="img-fluid mt-4 mb-1"
          src={vtLogo}
          style={{ width: "180px", margin: "auto", display: "block" }}
          alt="Vidyuttech logo"
        />

        <h5 style={{ color: "#7225F5" }} className="text-center mb-4">
          Vidyut Green Labs
        </h5>
        <section>
          <div className="row my-5">
            <h2>Privacy Policy</h2>
            <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
              Vidyut Green Labs, a company incorporated under the provisions of
              the Companies Act, 2013, having its registered office at 2
              <sup>nd</sup> Floor, 2<sup>nd</sup> Building, Hustlehub Techpark,
              27th Main Road End, HSR Layout Sector 1, Bangalore - 560102,
              Karnataka, India (hereinafter referred to as “Company” or “we” or
              “us”), is the owner of the website domain at
              "vidyutgreenlabs.com,", "vidyutgreenlabs.in" and a mobile
              application named "Vidyut" available on the Google Play
              Store/Apple App Store, respectively (collectively referred as
              “Platform”). This page informs a visitor or user (“you”, “your” or
              “User”) of the Platform of our policies regarding the collection,
              use, and disclosure of personal data when you use our Platform and
              the choices you have associated with that data (hereinafter
              referred to as “Privacy Policy”). We use your data to provide and
              improve the Platform. By using the Platform, you agree to the
              collection and use of information in accordance with this Privacy
              Policy.
            </p>
            <p>
              This Privacy Policy has been drafted and is published in
              compliance with The Information Technology Act, 2000, and
              applicable amendments, rules, regulations and guidelines enacted
              thereunder from time to time (“IT Act”) with specific mention of
              regulation 4 of the Information Technology (Reasonable Security
              Practices and Procedures and Sensitive personal information)
              Rules, 2011 (“SPDI Rules”) and the Information Technology
              (Intermediary Guidelines and Digital Media Ethics Code) Rules,
              2023, and any other national and state laws which relate the
              processing of data. This Privacy Policy is an electronic record in
              terms of the IT Act and this electronic record is generated by a
              computer system and does not require any physical or digital
              signatures. Any new features and/or services that are added to our
              current Services at any point in the future shall also be subject
              to the terms set out in this Privacy Policy along with any other
              future relevant legislations to be incorporated as per the laws of
              the land.
            </p>
            <p>
              We use your data to provide you Services and to improve the
              Platform as well as your experience of our Platform. By using the
              Platform, you agree to the collection and use of information in
              accordance with this Privacy Policy.
            </p>
            <ol className="nested">
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  INTRODUCTION AND APPLICABILITY OF THE PRIVACY POLICY
                </span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li className="nested">
                    We are strongly committed to respecting your online privacy
                    and recognize the need for appropriate protection and
                    management of any personal information collected, collated
                    and/or processed by us.
                  </li>
                  <li className="nested">
                    The purpose of this Privacy Policy is to ensure that there
                    is an intact charter that governs the collection, usage and
                    protection of any personal and/or sensitive data collected
                    by us. This Policy defines our procedure for collection,
                    usage, processing, disclosure and protection of any data or
                    information obtained by us through the Platform
                  </li>
                  <li className="nested">
                    Any reference made to Privacy Policy in this document shall
                    mean and refer to the latest version of the Privacy Policy
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">DISCLAIMER</span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li className="nested">
                    Please be advised that any Information (as defined herein
                    below) procured by us, shall be:
                    <ul style={{ listStylePosition: "inside" }}>
                      <li>
                        processed fairly and lawfully for rendering the Services
                        (as defined in the Terms of Service);
                      </li>
                      <li>
                        obtained only for specified and lawful purposes, and not
                        be used in any manner which is against the law or policy
                        in force in India (“Applicable Law”)
                      </li>
                      <li>
                        adequate, relevant and not excessive in relation to the
                        purpose for which it is required
                      </li>
                      <li>
                        able to be reviewed by the User, from time to time and
                        updated-if need arises; and
                      </li>
                      <li>
                        not kept longer than for the time which it is required
                        or the purpose for which it is required or as required
                        by the applicable law
                      </li>
                    </ul>
                  </li>
                  <li className="nested">
                    WE SHALL NOT BE LIABLE FOR ANY LOSS OR DAMAGE SUSTAINED BY
                    REASON OF ANY DISCLOSURE OF YOUR INFORMATION AND DATA
                    (INADVERTENT OR OTHERWISE), IF THE SAME IS EITHER (A)
                    REQUIRED FOR LEGITIMATE PURPOSES; OR (B) WAS EFFECTED
                    THROUGH NO FAULT, ACT, OR OMISSION OF THE COMPANY
                  </li>
                  <li className="nested">
                    BY USING THE PLATFORM OR SERVICES, YOU EXPLICITLY ACCEPT,
                    WITHOUT LIMITATION OR QUALIFICATION, THE COLLECTION, USE AND
                    TRANSFER OF THE INFORMATION IN THE MANNER DESCRIBED HEREIN
                  </li>
                  <li className="nested">
                    PLEASE READ THIS PRIVACY POLICY CAREFULLY AS IT AFFECTS YOUR
                    RIGHTS AND LIABILITIES UNDER LAW
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">YOUR CONSENT</span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li className="nested">
                    Please note that by providing the Information (as defined
                    herein below), you provide your consent and authorize us to
                    collect, use or disclose such Information for the business
                    and research purposes and as stated in this Privacy Policy
                    and as permitted or required by applicable law. Moreover,
                    you understand and hereby consent that this Information may
                    be disclosed/shared to any third party for the purpose of
                    providing Services through the Platform or to any
                    third-party providers for rendering Services, for any
                    jointly developed or marketed services, for payment
                    processing, for order fulfilment, customer services, data
                    analysis, information technology services and such other
                    services which enable us to provide Services through the
                    Platform or otherwise
                  </li>
                  <li className="nested">
                    This Privacy Policy shall be enforceable against you in the
                    same manner as any other written agreement. By visiting or
                    accessing the Platform and voluntarily providing us with
                    Information (including Personal Data), you are consenting to
                    our use of the Information, in accordance with this Privacy
                    Policy. If you do not agree with this Privacy Policy, you
                    may refuse or withdraw your consent any time, or
                    alternatively choose to not provide us with any Information.
                    Under such circumstance, we may be unable to render
                    Services.
                  </li>
                  <li className="nested">
                    Such an intimation to withdraw your consent can be sent to
                    [contactus@vidyuttech.com]. You understand that withdrawal
                    of consent shall lead to suspension of your "Vidyut" account
                    as we shall not be able to provide the Services to you.{" "}
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">TYPES OF DATA COLLECTED</span>
                <ol className="nested" style={{ listStylePosition: "inside" }}>
                  <li className="nested">
                    We collect several different types of information for
                    various purposes to provide and improve our Platform to you
                    <ul
                      style={{
                        textAlign: "justify",
                        wordBreak: "keep-all",
                        listStyleType: "disc",
                      }}
                    >
                      <li>
                        “Personal Data”, means and includes any Information that
                        relates to a natural person through which an individual
                        is identified, such as the name, contact details, email
                        address, gender, age, organization, employment status,
                        employer details, designation, income and years of
                        experience and any other information pertaining to a
                        User, including but not limited to information gathered
                        through availing Services, that is shared in the course
                        of availing the Services. We may also access your camera
                        and media files in your devices for various purposes
                        after seeking necessary permission.
                      </li>
                      <li>
                        “Sensitive Personal Data” means and includes information
                        relating to; (i) government ID cards; (ii) financial
                        information relating to such as bank account or credit
                        card or debit card or other payment instrument details,
                        credit score; (iii) any detail relating to the
                        above-mentioned points as provided to us for using the
                        Platform and (iv) Transaction Information.
                      </li>
                      <li>
                        “Transaction Information” means information that is
                        contained in text messages (that is, SMS) sent by
                        providers of Services and/or products (including but not
                        limited to financial institutions, mobile carriers and
                        utility companies) to your mobile telephone number(s) in
                        connection with one or more transactions across multiple
                        financial accounts (including purchase, payments,
                        billing information and service notifications related
                        thereto) including the notifications sent on the User’s
                        mobile.
                      </li>
                      <li>
                        “Technical Information” means and includes any
                        Information gathered through various technologies that
                        may employ cookies, web beacons, or similar technologies
                        to automatically record certain information from your
                        device through which you use the Platform. This
                        technical information may include your Internet Protocol
                        (IP) address, device or browser type, Internet service
                        provider (ISP), referring or exit pages, clickstream
                        data, operating system, hardware model, operating system
                        version, unique device identifiers, and mobile network.
                        This data includes usage information and user
                        statistics.
                      </li>
                      <li>
                        “Locational Information” shall mean and include the
                        information obtained through GPS or other means, such as
                        the geographical location of the User
                      </li>
                      <li>
                        “Non-Personal Information” means and includes any
                        information that does not reveal your specific identity,
                        such as, browser information, information collected
                        through Cookies (as defined below), pixel tags and other
                        technologies, demographic information, etc. As is true
                        with most websites, our Company gathers some information
                        automatically when you visit the Platform. When you use
                        the Platform, we may collect certain information about
                        your computer or mobile to facilitate, evaluate and
                        verify your use of the Platform. For example, we may
                        store environmental variables, such as browser type,
                        operating system, speed of the central processing unit
                        (CPU), referring or exit web pages, click patterns and
                        the internet protocol (IP) address of your computer.
                        This information is generally collected in aggregate
                        form, without identifying any user individually.
                      </li>
                    </ul>
                  </li>
                </ol>

                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  The above-mentioned information shall be collectively referred
                  to as “Information”
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">USE OF DATA</span>
                <ol className="nested">
                  <li className="nested">
                    We understand the importance of your Personal and
                    Non-Personal Information and ensure that it is used for the
                    intended purpose only. We access, store, and use the
                    combined information we collect from you in accordance with
                    the Applicable Laws to provide our Services, to research and
                    develop new ones subject to the limitations set out in this
                    Privacy Policy.
                  </li>
                  <li className="nested">
                    In addition to the uses mentioned in clause 3.1, the
                    Information collected by us shall be used for following
                    functions including but not limited to:
                    <ul
                      style={{
                        textAlign: "justify",
                        wordBreak: "keep-all",
                        listStyleType: "disc",
                        listStylePosition: "inside",
                      }}
                    >
                      <li>to render Services;</li>
                      <li>
                        to verify your identity for us to provide or offer
                        products/ Services to you;
                      </li>
                      <li>
                        to carry screenings, audits, due diligence checks and/or
                        record keeping purposes as lawfully required by us;
                      </li>
                      <li>
                        financial reporting, regulatory reporting, management
                        reporting, risk management (including monitoring credit
                        exposures), audit and record keeping purposes;
                      </li>
                      <li>
                        to evaluate the quality and competence of our personnel;
                      </li>
                      <li>
                        to resolve any complaints, you may have and ensure that
                        you receive the highest quality of Services
                      </li>
                      <li>notifying you about changes to our Platform;</li>
                      <li>
                        providing analysis or valuable information so that we
                        can improve the Platform;
                      </li>
                      <li>
                        monitoring and maintaining the usage of the Platform;
                      </li>
                      <li>
                        sending out system updates on the booked services,
                      </li>
                      <li>
                        detecting, preventing and addressing technical issues;
                      </li>
                      <li>analyse usage patterns;</li>
                      <li>Improve user experience;</li>
                      <li>
                        to use it in other ways as required or permitted by law
                        or with your consent;
                      </li>
                      <li>
                        re-marketing campaigns (SMS, WhatsApp message, email, PN
                        campaigns);
                      </li>
                      <li>targeted marketing campaigns, periodic follow-ups</li>
                      <li>Notify you about new services and features.</li>
                    </ul>
                  </li>

                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    Business or Research Purposes: The Information save and
                    accept Personal Information, will be used for business or
                    research purposes, including improving and customizing the
                    Platform for ease of use and the services offered by us. We
                    may archive this information to use it for future
                    communications for providing updates and/or surveys.
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    Aggregating Information / Anonymized data: We may aggregate
                    Information and analyse it in a manner to further improve
                    the level of services that we offer to our customers. This
                    Information includes average number of Users of the
                    Platform, the average clicks of the services/, the features
                    used, the response rate, etc. and other such statistics
                    regarding groups or individuals.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  DISCLOSURE AND SHARING OF INFORMATION:
                </span>
                <ol className="nested">
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    We do not rent, sell or disclose or share any Information
                    that we collect from you, with third parties, save and
                    except in order to provide you with the Services. Any such
                    disclosure, if made, shall be in accordance to this Privacy
                    Policy and as per the procedure prescribed by law and in
                    compliance with our legal obligations. We may share your
                    Information in circumstances and for the purposes as
                    specified hereunder:
                    <ol style={{ listStyleType: "lower-alpha" }}>
                      <li>
                        We may share the information to the third-party service
                        providers/ vendors, to provide you with the Servicesor
                        to improve the Services or to evaluate any possible
                        business arrangement with third parties which may
                        enhance the quality of Services being provided or to
                        evaluate whether Services may be provided to you. This
                        may include but not be limited to Lenders (as defined in
                        the Terms), storage providers, data analytics providers,
                        consultants, lawyers, providers of various services and
                        auditors
                      </li>
                      <li>
                        When compelled by law, we may disclose any Information
                        provided by you on the Platform as may be deemed to be
                        necessary or appropriate:
                        <ul style={{ listStylePosition: "inside" }}>
                          <li>
                            under applicable law, including laws outside your
                            country of residence;
                          </li>
                          <li>to comply with legal process;</li>
                          <li>
                            to respond to requests from public, Regulatory and
                            government authorities including public and
                            government authorities outside your country of
                            residence;
                          </li>
                          <li>
                            to allow us to comply with any judgement or decree
                            or order issued under any law for the time being in
                            force in India, or any judgment or order relating to
                            claims of a contractual or civil nature under any
                            law for the time being in force outside India;
                          </li>
                          <li>
                            to protect our operations or those of any of our
                            affiliates;
                          </li>
                          <li>
                            to protect our rights, privacy, safety or property,
                            and/that of our affiliates, you or others;
                          </li>
                          <li>
                            to allow us to pursue available remedies or limit
                            the damages that we may sustain; or
                          </li>
                          <li> to protect against legal liability;</li>
                          <li>
                            to protect the personal safety of Users of the
                            Platform;
                          </li>
                          <li>
                            to prevent or investigate possible wrongdoing in
                            connection with the Platform.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Merger or Acquisition: We may share Information upon
                        merger or acquisition of Company with another company,
                        which shall automatically acquire the rights and
                        obligations as per the Policy. We shall transmit and
                        transfer the Information upon acquisition or merger of
                        Company with another company
                      </li>
                      <li>
                        With our service providers: We may share Information
                        (including Personal Data and Sensitive Personal Data)
                        with other service providers on a need- to-know basis,
                        subject to obligations of confidentiality for provision
                        of Services. We hereby clarify that Company works with
                        institutions, vendors, partners, advertisers, and other
                        service providers, including (but not limited) to those
                        who provide services such as contact Information
                        verification, website hosting, data analysis, providing
                        infrastructure, information technology services,
                        auditing services and other similar services, in
                        different industries and categories of business by
                        virtue of lawful contracts instituted between such third
                        parties and Company to improve our services.
                        Accordingly, we may share your Information with such
                        service provider as reasonably necessary to provide you
                        with Services.
                      </li>
                      <li
                        style={{ textAlign: "justify", wordBreak: "keep-all" }}
                      >
                        Employees /Agents of Company: We follow a strict
                        confidentiality policy with regards to disclosure of
                        confidential information to our employees or other
                        personnel. There may be situations, where we may
                        disclose the confidential information only to those of
                        our employees and other personnel on a need-to-know
                        basis. Any breach of confidential information by the
                        employees, personnel within the Company is dealt with
                        stringently by us.
                      </li>
                      <li
                        style={{ textAlign: "justify", wordBreak: "keep-all" }}
                      >
                        We may, at our option, remove parts of data that can
                        identify you and share anonymized data with other
                        parties. We may also combine your information with other
                        information in a way that it is no longer associated
                        with you and share that aggregated information
                      </li>
                      <li
                        style={{ textAlign: "justify", wordBreak: "keep-all" }}
                      >
                        Except for the Information disclosed pursuant to
                        sub-clause (a) to (f) of Clause 6.1 above, Company may
                        share Information only if you authorize us to do so
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">TRANSFER OF DATA</span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li className="nested">
                    Your Information may be transferred to, and maintained on,
                    computers located in India, and will be governed by the
                    Indian data protection laws.
                  </li>
                  <li className="nested">
                    If you are located outside India and choose to provide
                    information to us, please note that we may transfer the data
                    to India to process the Information.
                  </li>
                  <li className="nested">
                    Your consent to this Privacy Policy followed by your
                    submission of such information represents your agreement to
                    that transfer or use.
                  </li>
                  <li className="nested">
                    We will take all steps reasonably necessary to ensure that
                    your data is treated securely and in accordance with this
                    Privacy Policy and no transfer of your data will take place
                    to an organization or a country unless there are adequate
                    controls in place including the security of your data.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">YOUR RIGHTS</span>
                <ol className="nested">
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    You can always choose not to provide the requested
                    information to us, it may however result in you not availing
                    certain features or the entire set of our Services.
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    You retain several rights in relation to your Personal Data
                    as provided under applicable law. These may include the
                    rights to:
                    <ul
                      style={{
                        textAlign: "justify",
                        wordBreak: "keep-all",
                        listStylePosition: "inside",
                      }}
                    >
                      <li>
                        access, confirm, and review Personal Data you may have
                        provided;
                      </li>
                      <li>
                        correct Personal Information that may be inaccurate or
                        irrelevant;
                      </li>
                      <li>
                        nominate any other individual, who shall in event of
                        death or incapacity exercise the rights provided to you;
                      </li>
                      <li>
                        deletion and erasure of your Personal Data from the
                        publicly available pages of the Platform;
                      </li>
                      <li>
                        receive Personal Information we hold about you in a
                        portable format;
                      </li>
                      <li>
                        object to or restrict any form of processing you may not
                        be comfortable with.
                      </li>
                    </ul>
                  </li>

                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    In order to exercise these rights, please contact us on the
                    email address provided in Clause 3.3 above.
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    If you want to withdraw your consent or raise any objection
                    to the use of your information for receiving any direct
                    marketing information to which you previously opted-in, you
                    can do so by contacting our customer support at above
                    mentioned addresses. If you withdraw/object your consent,
                    our use of your information before you withdrew/objected
                    shall still be lawful.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">APPLICATIONS USED</span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li className="nested">
                    You may be availing our services for using third party
                    mobile applications, which are not operated by us. We
                    strongly advise you to review the privacy policy of every
                    mobile application which you may use.
                  </li>
                  <li className="nested">
                    We have no control over and assume no responsibility for the
                    content, privacy policies or practices of any third-party
                    mobile applications or services.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">CHILDREN’S PRIVACY</span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  Our Platform and Services are not meant for use by children
                  and we knowingly do not collect or solicit Personal
                  Information of/from anyone under the age of 18. If you are
                  under 18, please do not attempt to register for the Services
                  or send any personal information about yourself to us. If it
                  comes to our notice that we have collected Information from/of
                  children, we shall take steps to remove such Information from
                  our servers. If you believe that we might have any Information
                  that may have been collected from a child or has been provided
                  by a child, please write to us at the email id provided in
                  Clause 3.3
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  CONTROL THE COLLECTION OR USE OF THE INFORMATION
                </span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  If you have any reservations, constraints or apprehensions
                  regarding the access to, collection, storage, or any other use
                  of the Information which you have provided to us, you may
                  withdraw your consent by writing to us on the email provided
                  as hereinabove.
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">RETENTION OF INFORMATION</span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  All Information provided by you, save and except upon
                  withdrawal or termination, may be retained in locations
                  outside the direct control of Company (for instance, on
                  servers or databases co-locates with hosting providers). We
                  will delete Information based on a request received from you
                  within a reasonable period and latest within 90 (ninety) days
                  of receiving a deletion request. However, we may retain such
                  portion of Information and for such periods as may be required
                  under Applicable Law. Notwithstanding anything contained
                  herein, Company may retain data after account deletion for
                  reasons including but limited to the following purposes: If
                  there is an unresolved issue relating to your account, or an
                  unresolved claim or dispute; If we are required to by
                  applicable law; and/or in aggregated and/or anonymized form;
                  or Company may also retain certain information if necessary
                  for its legitimate business interests, such as fraud
                  prevention and enhancing Users' safety and security
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  COOKIES AND OTHER TRACKING TECHNOLOGIES
                </span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  Our Platform may utilize “cookies” and other Technical
                  Information. “Cookies” are a small text file consisting of
                  alphanumeric numbers used to collect the Information about
                  Platform activity. The Technical Information helps us analyse
                  web traffic and helps you by customizing the Platform to your
                  preferences. Cookies in no way gives us access to your
                  computer or mobile device. In relation to Cookies, you can
                  deny access to the installation of the Cookies by modifying
                  the settings on your web browser, however, this may prevent
                  you from taking full advantage of the Platform. Our use of
                  Cookies and Technical Information allows us to improve
                  Platform and your experience of Platform and Services. We may
                  also analyse Technical Information that does not contain
                  Personal Information for trends and statistics.
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">THIRD PARTY SERVICES</span>
                <ol
                  className="nested"
                  style={{ textAlign: "justify", wordBreak: "keep-all" }}
                >
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    We may use your Information to send you promotional
                    Information about third parties which, we think you may find
                    interesting, if you tell us that you wish this to happen. We
                    shall not be responsible for any disclosure of Information
                    due to unauthorized third-party access or other acts of
                    third parties or acts or omissions beyond our reasonable
                    control and you agree that you will not hold us responsible
                    for any breach of security unless such breach has been
                    caused as a direct result of our negligence or wilful
                    default
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    Once you leave the Platform, we are not liable for any use/
                    storage/ processing/ collection of your information obtained
                    by any third-party websites or payment facilitators or
                    provided by you to these third-parties or payment
                    facilitators. Such entities and their respective
                    websites/platforms may be governed by their own “Privacy
                    Policy” and “Terms of Service”, which are beyond our
                    control.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">DATA SECURITY</span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  We work to protect the security of your Personal Information
                  during transmission by using appropriate software, which
                  encrypts information you input. This encrypted information is
                  stored on secure servers and data centres. You agree and
                  accept that your Information may be stored in third-party
                  cloud service infrastructure providers. While all reasonable
                  attempts have been taken from our end to ensure the safe and
                  secure storage of your data, we shall not be liable for any
                  data breach on the part of the third-party cloud service
                  infrastructure provider that was beyond our control. In
                  addition to the security measures put in place by the
                  third-party cloud service infrastructure provider for safe and
                  secure storage of your Information, we use certain physical,
                  managerial, technical or operational safeguards as per
                  industry standards and established best practices to protect
                  the Information we collect. We use reasonable security
                  practices and procedures and use secure servers as mandated
                  under applicable laws for the protection of your Information.
                  We review our Information collection, storage, and processing
                  practices, including physical security measures to guard
                  against unauthorized access to systems. However, as effective
                  as these measures are, no security system is impenetrable. We
                  cannot guarantee the security of our database, nor can we
                  guarantee that the Information you supply will not be
                  intercepted while being transmitted to us over the internet.
                  You accept the inherent security implications of data
                  transmission over the internet and the internet cannot always
                  be guaranteed as completely secure. Therefore, your use of the
                  Platform will be at your own risk. If you have any concerns,
                  please feel free to contact us at the details given in Clause
                  3.3 above.
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  CHANGES AND UPDATES TO POLICY
                </span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  We may modify or revise the Privacy Policy from time to time
                  and shall accordingly notify you of any changes to the Privacy
                  Policy by posting the revised Privacy Policy on the Platform
                  with an updated date of revision. We shall endeavour to
                  review, revise, update, modify, amend or correct the Privacy
                  Policy on a regular and routine basis, especially whenever a
                  significant update is made to the technology employed by us.
                  You must periodically review the Privacy Policy for the latest
                  information on our privacy practices. In the event you
                  continue to use the Platform and our services after any update
                  in the Privacy Policy, your use of the Platform shall be
                  automatically subject to such updated privacy policy, without
                  any requirement on our part to give a specific notice thereof.
                  Your continued usage of Services or access of the Platform
                  post any amendment would deem to mean that you accept and
                  agree to the revised Privacy Policy. Further, we retain the
                  right at any time to deny or suspend access to all, or any
                  part of, the service to anyone who we reasonably believe has
                  violated any provision of this Privacy Policy
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  DISCREPANCIES AND GRIEVANCES WITH COMPANY
                </span>
                <ol className="nested">
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    In case of any discrepancy or grievance with respect to all
                    or any Information shared with Company, please feel free to
                    contact our Grievance Officer: <br /> Attention: Mr. Gaurav
                    Srivastava <br /> Email: gro@vidyuttech.com
                    <br /> Address: 2<sup>nd</sup> Floor, 2<sup>nd</sup>{" "}
                    Building, Hustlehub Techpark, 27th Main Road End, HSR Layout
                    Sector 1, Bangalore - 560102, Karnataka, India
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    We assure you that we shall ensure implementation of the
                    Privacy Policy and shall make the Privacy Policy available
                    to Users. We will acknowledge each grievance that is
                    received within 24 hours and put our best efforts to redress
                    the grievances of the User expeditiously within fifteen (15)
                    days from the date of receipt of the grievance. The User
                    agrees and acknowledges that the Company shall address and
                    attempt to resolve the complaint received in accordance with
                    the standard policies and procedures adopted by the Company,
                    the User’s disapproval/discontent with the outcome/mode of
                    redressal shall not be deemed to mean non-redressal of the
                    grievance by the Company. Any suggestions by Company
                    regarding use of the Service shall not be construed as a
                    warranty
                  </li>
                  <li
                    className="nested"
                    style={{ textAlign: "justify", wordBreak: "keep-all" }}
                  >
                    Please feel free to reach out to us by
                    contactus@vidyuttech.com in case of any concerns,
                    grievances, or questions relating to our privacy or data
                    related practices.
                  </li>
                </ol>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">MISCELLANEOUS</span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  THE INVALIDITY OR UNENFORCEABILITY OF ANY PART OF THIS PRIVACY
                  POLICY SHALL NOT PREJUDICE OR AFFECT THE VALIDITY OR
                  ENFORCEABILITY OF THE REMAINDER OF THIS PRIVACY POLICY. THIS
                  PRIVACY POLICY DOES NOT APPLY TO ANY INFORMATION OTHER THAN
                  THE INFORMATION COLLECTED BY US THROUGH THE PLATFORM. THIS
                  PRIVACY POLICY SHALL BE INAPPLICABLE TO ANY UNSOLICITED
                  INFORMATION YOU PROVIDE US THROUGH THE PLATFORM OR THROUGH ANY
                  OTHER MEANS. ALL UNSOLICITED INFORMATION SHALL BE DEEMED TO BE
                  NON-CONFIDENTIAL AND WE SHALL BE FREE TO USE AND/ OR DISCLOSE
                  SUCH UNSOLICITED INFORMATION WITHOUT ANY LIMITATIONS. THE
                  RIGHTS AND REMEDIES AVAILABLE UNDER THIS POLICY MAY BE
                  EXERCISED AS OFTEN AS NECESSARY AND ARE CUMULATIVE AND NOT
                  EXCLUSIVE OF RIGHTS OR REMEDIES PROVIDED BY LAW. RIGHTS UNDER
                  THIS POLICY MAY BE WAIVED ONLY IN WRITING. DELAY IN EXERCISING
                  OR NON-EXERCISE OF ANY SUCH RIGHT OR REMEDY DOES NOT
                  CONSTITUTE A WAIVER OF THAT RIGHT OR REMEDY, OR ANY OTHER
                  RIGHT OR REMEDY
                </p>
              </li>
              <br />
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  GOVERNING LAWS AND JURISDICTION
                </span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  This Privacy Policy, the Platform, the Services and the use of
                  it is governed by the laws of India and the courts in
                  Bangalore, in India shall have exclusive jurisdiction over any
                  disputes connected to our Privacy Policy, Platform or the
                  Services and your use of it.
                </p>
              </li>
              <li className="nested increase-font-size">
                <span className="fw-medium fs-4">
                  YOUR ACCEPTANCE OF THESE TERMS
                </span>
                <p style={{ textAlign: "justify", wordBreak: "keep-all" }}>
                  BY USING OR VISITING THIS PLATFORM, YOU SIGNIFY YOUR AGREEMENT
                  OF THIS POLICY. IF YOU DO NOT AGREE TO ANY OF THESE TERMS,
                  PLEASE DO NOT USE OUR PLATFORM OR SERVICES
                </p>
              </li>
            </ol>
          </div>
        </section>
      </div>
    </>
  );
};
export default PrivacyPolicy;
